module.exports = __webpack_public_path__ + "static/media/tb_tw.f15577d1.pdf";